import { Box, Chip, styled, Tooltip, tooltipClasses, useTheme } from "@mui/material";
import { useState } from "react";
import { toast } from "react-toastify";

export const downloadFileFromBlob = (data, filename, mime, bom) => {
    const blobData = typeof bom !== "undefined" ? [bom, data] : [data];
    const blob = new Blob(blobData, { type: mime || "application/octet-stream" });
    if (typeof window.navigator.msSaveBlob !== "undefined") {
        // IE workaround for "HTML7007: One or more blob URLs were
        // revoked by closing the blob for which they were created.
        // These URLs will no longer resolve as the data backing
        // the URL has been freed."
        window.navigator.msSaveBlob(blob, filename);
    } else {
        const blobURL =
            window.URL && window.URL.createObjectURL
                ? window.URL.createObjectURL(blob)
                : window.webkitURL.createObjectURL(blob);
        const tempLink = document.createElement("a");
        tempLink.style.display = "none";
        tempLink.href = blobURL;
        tempLink.setAttribute("download", filename);

        // Safari workaround
        if (typeof tempLink.download === "undefined") {
            tempLink.setAttribute("target", "_blank");
        }

        document.body.appendChild(tempLink);
        tempLink.click();

        // Cleanup after download
        setTimeout(function () {
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
        }, 200);
    }
};

export default function ErrorHandler(result) {
    let data = result?.payload;
    if (data?.status) {
        if (data?.status === 500 || data?.status === 502) {
            toast.error(data?.message);
            return false;
        } else if (data?.status === 404) {
            toast.error(data?.message);
            return false;
        } else if (data?.status === 400) {
            toast.error(data?.message);
            return false;
        } else if (data?.status === 409) {
            toast.error(data?.message);
            return false;
        } else if (data?.status === 403) {
            toast.error(data?.message);
            return false;
        } else if (data?.status === 401) {
            // toast.error(data?.message);
            localStorage.clear();
            // window.location.href = "/";
            return false;
        } else {
            return true;
        }
    } else {
        // swal("error", "Something went wrong!", "error");
        toast.error("Something went wrong!")
        return false;
    }
}

export const getFileIcon = (originalDocArray) => {
    console.log(originalDocArray, "originalDocArray");  // Debugging originalDocArray
    let fileType = "";

    // Loop through the originalDocArray to extract the file extension
    originalDocArray.forEach(url => {
        // Extract the file extension using a regular expression
        const possibleFile = url.match(/([a-zA-Z0-9_-]+)(?=\.[a-zA-Z]+$)/); // Match the part before the last dot
        console.log("Detected URL:", url);  // Debug URL path
        console.log("Detected file extension:", possibleFile);  // Debug the file extension

        // If a match is found, extract the file extension and map it
        if (possibleFile && possibleFile[0]) {
            const extension = url.split('.').pop().toLowerCase(); // Get the extension after the last dot

            switch (extension) {
                case "png":
                    fileType = "png";
                    break;
                case "jpg":
                case "jpeg":
                    fileType = "jpg";
                    break;
                case "gif":
                    fileType = "gallery";
                    break;
                case "doc":
                case "docx":
                    fileType = "doc";
                    break;
                case "ppt":
                case "pptx":
                    fileType = "ppt";
                    break;
                case "pdf":
                    fileType = "pdf";
                    break;
                case "xls":
                case "xlsx":
                    fileType = "xls";
                    break;
                case "txt":
                    fileType = "txt";
                    break;
                default:
                    fileType = "file";
            }
        }
    });

    console.log("Final file type:", fileType);  // Debug the final file type
    return fileType;
};


export function SidebarIcon({ src, width, height }) {
    return (
        <>
            <img src={src} alt='icon' width={width} height={height} />
        </>
    )
}
export const converOctateToType = async ({ url, type }) => {
    const b = await fetch(url).then((d) => d.blob());
    return b.slice(0, b.size, type);
};
export function ImageWrapper({ src, width, height }) {
    return <img src={src} alt='icon' width={width} height={height} />
}

export function CommonChip({ label, height, width, margin, padding, fontSize }) {
    return (
        <>
            <Chip label={label}
                sx={{
                    backgroundColor: label === "Pending" ?
                        "#F8D270" : label === "Rejected" ?
                            "#eb5454" : label === "Partial-Rejected" ?
                                "#eb5454" : label === "Not-Interested" ?
                                    "#eb5454" : (label === "Approved" || label === "Accepted") ?
                                        "#00D47EB8" : (label === "Draft" || label === "Login Users") ?
                                            "#c8c8c8" : label === "Re-Uploaded" ?
                                                "#75bac4" : "#c8c8c8",
                    color: "#FFFFFF",
                    height: height || "28px",
                    width: width,
                    margin: margin,
                    fontSize: fontSize,
                    "& .MuiChip-label": {
                        padding: padding
                    },
                    borderRadius:'6px'
                }}
            />
        </>
    )
}

export function PaymentStatus({ label, height, width, margin, padding }) {
    const theme = useTheme()
    return (
        <>
            <Chip label={label}
                sx={{
                    backgroundColor: label === "SUCCESS" ? theme.palette.success.main
                        : (label === "FAILURE" || label?.toLowerCase() === "cancel") ? theme.palette.error.main
                            : label === "PENDING" ? theme.palette.primary.main : "#0C0C0C",
                    color: "#FFFFFF",
                    height: height || "28px",
                    width: width,
                    margin: margin,
                    "& .MuiChip-label": {
                        padding: padding
                    }
                }}
            />
        </>
    )
}

export function CommonChipFollowUpStatus({ label, height, fontSize }) {
    return (
        <>
            <Chip label={label}
                sx={{
                    backgroundColor: label === "Pending" ?
                        "#F8D270" : label === "OnHold" ?
                            "#eb5454" : label === "Follow up running on call" ?
                                "#eb5454" : label === "Meeting done but confirmation pending" ?
                                    "#eb5454" : (label === "Not-Intersted" || label === "Not-Interested") ?
                                        "#eb5454" : label === "Confirmed" ?
                                            "#00D47EB8" : label === "Coming for verification" ?
                                                "#00D47EB8" : label === "Meeting done" ?
                                                    "#c8c8c8" : label === "Meeting time scheduled but not come yet" ?
                                                        "#75bac4" : "#FFFFFF",
                    color: "#FFFFFF",
                    fontSize: fontSize || "12px", height: height || "20px",
                    borderRadius:'6px'
                }}
            />
        </>
    )
}

export const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
    },
}));

export const ReadMore = ({ content, align, contentLength = 50 }) => {
    const theme = useTheme()
    const [isExpanded, setIsExpanded] = useState(false);
    const toggleExpanded = () => setIsExpanded((prev) => !prev);

    const truncatedContent =
        content?.length > contentLength
            ? content.substring(0, contentLength)
            : content;

    return (
        <Box align={align || "center"}>
            {isExpanded ? content : truncatedContent}
            {content?.length > contentLength && (
                <span
                    onClick={toggleExpanded}
                    style={{ color: theme?.palette?.primary?.main, cursor: "pointer", marginLeft: 8, fontSize: 13, fontWeight: 'bold' }}
                >
                    {isExpanded ? "ReadLess" : "ReadMore"}
                </span>
            )}
        </Box>
    );
};

export const checkAccess = (pathname, pageAccessConfig, ...actionsType) => {
    const basePathname = `/${pathname.split('/')[1]}`;
    const access = pageAccessConfig?.find((val) => val.path === basePathname);
    return actionsType.every((type) => access?.actionsType?.includes(type));
};


export const formattedDate = (date) => { return date?.split('/')?.reverse()?.join('/'); }

export const calculateAgeAndMonth = (dob) => {
    // Parse the input date string to detect format and create a Date object
    const parts = dob?.includes('/') ? dob?.split('/') : dob?.split('-');
    let birthDate;

    if (parts?.length === 3) {
        if (parts[0]?.length === 4) {
            birthDate = new Date(parts[0], parts[1] - 1, parts[2]);
        } else {
            birthDate = new Date(parts[2], parts[1] - 1, parts[0]);
        }
    } else {
        return "Invalid date format";
    }

    const today = new Date();
    let age = today?.getFullYear() - birthDate?.getFullYear();
    let months = today?.getMonth() - birthDate?.getMonth();

    if (months < 0 || (months === 0 && today?.getDate() < birthDate?.getDate())) {
        age--;
        months += 12;
    }

    return months > 0 ? `${age} Year /${months} Month` : `${age} Year`;
};

export const getValuebyId = (value, data) => {
    return data?.find((val) => val?.label === value)?.value
}

export const getLabelbyId = (value, data) => {
    // return data?.find((val) => val?.value === value)?.label
    const temp = data?.find((ele) => {
        return ele?.value === value || ele?.label === value;
    });

    return temp ? temp?.label : undefined;
}

export const capitalizeFirstLetterOfWords = (input) => {
    return input
        ?.split(' ') // Split into words
        ?.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter & make rest lowercase
        ?.join(' '); // Join back into a string
};

export const PaymentShowBox = ({ value }) => {
    const theme = useTheme();
    return (
        <Box
            sx={{
                padding: "3px 5px",
                fontSize: "11px",
                color: "#fff",
                borderRadius: "15px",
                backgroundColor: value === "SUCCESS" ? theme.palette.success.main : (value === "FAILURE" || value?.toLowerCase() === "cancel") ? theme.palette.error.main : value === "CANCEL" ? theme.palette.error.main : value === "PENDING" ? theme.palette.bgLightBlack.main : ""
            }}
        >
            {value}
        </Box >
    );
};

export function CommonStatusBox({ label, height, fontSize }) {
    return (
        <>
            <Chip label={label}
                sx={{
                    backgroundColor: label === "Re-Uploaded" ?
                        "#F8D270" : label === "Partial-Rejected" ?
                            "#eb5454" : "#FFFFFF",
                    color: "#FFFFFF",
                    fontSize: fontSize || "12px", height: height || "20px",
                    borderRadius:'6px'
                }}
            />
        </>
    )
}

export function CommonStatusChip({ label }) {
    return (
        <>
            <Chip label={label}
                sx={{
                    backgroundColor: label === "Pending" ?
                        "rgba(255, 243, 219, 1)" : (label === "Rejected" || label === "Inactive") ?
                            "rgba(255, 240, 241, 1)" : (label === "Approved" || label === "Active") ? "rgba(231, 248, 241, 1)" : "#FFFFFF",
                    color: label === "Pending" ?
                        "rgba(252, 171, 17, 1)" : (label === "Rejected" || label === "Inactive") ?
                            "rgba(227, 54, 41, 1)" : (label === "Approved" || label === "Active") ? "rgba(11, 176, 108, 1)" : "#FFFFFF",
                    fontSize: "12px",
                    height: "26px",
                    borderRadius:'6px',
                    border:`2px solid ${label === "Pending" ?
                        "rgba(252, 171, 17, 1)" : (label === "Rejected" || label === "Inactive") ?
                            "rgba(227, 54, 41, 1)" : (label === "Approved" || label === "Active") ? "rgba(11, 176, 108, 1)" : "#FFFFFF"}`
                }}
            />
        </>
    )
}